<template>
  
  
  <div class="mt-6">
    <div class="container-fluid">
      <div class="row-fluid-wrapper">
        <div class="row-fluid">
          <div class="span12 widget-span widget-type-cell " style="" data-widget-type="cell" data-x="0" data-w="12">
            <div class="row-fluid-wrapper row-depth-1 row-number-1 dnd-section dnd_area_footer-row-0-padding dnd_area_footer-row-0-background-layers dnd_area_footer-row-0-background-color">
              <div class="row-fluid ">
                <div class="span12 widget-span widget-type-cell dnd-column" style="" data-widget-type="cell" data-x="0" data-w="12">
                  <div class="row-fluid-wrapper row-depth-1 row-number-2 dnd-row">
                    <div class="row-fluid ">
                      <div class="span12 widget-span widget-type-custom_widget dnd-module" style="" data-widget-type="custom_widget" data-x="0" data-w="12">
                        <div class="hs_cos_wrapper hs_cos_wrapper_widget hs_cos_wrapper_type_module widget-type-rich_text" style="" data-hs-cos-general-type="widget" data-hs-cos-type="module">
                          <span class="hs_cos_wrapper hs_cos_wrapper_widget hs_cos_wrapper_type_rich_text" style="" data-hs-cos-general-type="widget" data-hs-cos-type="rich_text">
                            <p style="text-align: center;">
                              <span style="color: #ffffff;">© Copyright GN Srl 2020 General Networking - Strada Scaglia Est,&nbsp;33 - 41126&nbsp;Modena</span>
                            </p>
                            <p style="text-align: center;">
                              <span style="color: #ffffff;">P.Iva/Cf&nbsp;02610840361 -&nbsp;Rea MO-316301 - Cap.Soc 25000€ I.V.&nbsp; <a href="https://www.gnet.it/privacy-policy?hsLang=it-it" rel="noopener" style="color: #ffffff;">Privacy Policy</a></span>
                            </p> 
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  name: 'clickerfooter',
  components: { },
  
  data: function() {
    return { };
  },
  
  mounted: function() { },
  
  methods: { },
}
</script>

<style>

#hs_cos_wrapper_widget_1715850937749 {
  display: block !important;
  padding-bottom: 40px !important;
  padding-top: 40px !important
}

#hs_cos_wrapper_widget_1715850937749 {
  display: block !important;
  padding-bottom: 40px !important;
  padding-top: 40px !important
}

.dnd_area-row-0-max-width-section-centering>.row-fluid {
  max-width: 900px !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

.dnd_area-row-5-max-width-section-centering>.row-fluid {
  max-width: 1000px !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

.dnd_area-row-8-force-full-width-section>.row-fluid {
  max-width: none !important;
}

.module_17152579202108-flexbox-positioning {
  display: -ms-flexbox !important;
  -ms-flex-direction: column !important;
  -ms-flex-align: center !important;
  -ms-flex-pack: start;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: flex-start;
}

.module_17152579202108-flexbox-positioning>div {
  max-width: 100%;
  flex-shrink: 0 !important;
}

.dnd_area-dnd_partial-2-module-2-flexbox-positioning {
  display: -ms-flexbox !important;
  -ms-flex-direction: column !important;
  -ms-flex-align: center !important;
  -ms-flex-pack: start;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: flex-start;
}

.dnd_area-dnd_partial-2-module-2-flexbox-positioning>div {
  max-width: 100%;
  flex-shrink: 0 !important;
}

/* HubSpot Non-stacked Media Query Styles */
@media (min-width:768px) {
  .dnd_area-row-1-vertical-alignment>.row-fluid {
    display: -ms-flexbox !important;
    -ms-flex-direction: row;
    display: flex !important;
    flex-direction: row;
  }
  
  .dnd_area-row-3-vertical-alignment>.row-fluid {
    display: -ms-flexbox !important;
    -ms-flex-direction: row;
    display: flex !important;
    flex-direction: row;
  }
  
  .dnd_area-dnd_partial-3-column-1-vertical-alignment {
    display: -ms-flexbox !important;
    -ms-flex-direction: column !important;
    -ms-flex-pack: center !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
  }
  
  .dnd_area-dnd_partial-3-column-1-vertical-alignment>div {
    flex-shrink: 0 !important;
  }
  
  .cell_17152587627382-vertical-alignment {
    display: -ms-flexbox !important;
    -ms-flex-direction: column !important;
    -ms-flex-pack: center !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
  }
  
  .cell_17152587627382-vertical-alignment>div {
    flex-shrink: 0 !important;
  }
  
  .cell_17152587627382-row-0-vertical-alignment>.row-fluid {
    display: -ms-flexbox !important;
    -ms-flex-direction: row;
    display: flex !important;
    flex-direction: row;
  }
  
  .dnd_area-dnd_partial-2-module-1-vertical-alignment {
    display: -ms-flexbox !important;
    -ms-flex-direction: column !important;
    -ms-flex-pack: center !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
  }
  
  .dnd_area-dnd_partial-2-module-1-vertical-alignment>div {
    flex-shrink: 0 !important;
  }
  
  .cell_1715258762736-vertical-alignment {
    display: -ms-flexbox !important;
    -ms-flex-direction: column !important;
    -ms-flex-pack: center !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
  }
  
  .cell_1715258762736-vertical-alignment>div {
    flex-shrink: 0 !important;
  }
  
  .cell_1715258762736-row-0-vertical-alignment>.row-fluid {
    display: -ms-flexbox !important;
    -ms-flex-direction: row;
    display: flex !important;
    flex-direction: row;
  }
  
  .dnd_area-dnd_partial-2-module-2-vertical-alignment {
    display: -ms-flexbox !important;
    -ms-flex-direction: column !important;
    -ms-flex-pack: center !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
  }
  
  .dnd_area-dnd_partial-2-module-2-vertical-alignment>div {
    flex-shrink: 0 !important;
  }
  
  .cell_1739286680707-row-0-vertical-alignment>.row-fluid {
    display: -ms-flexbox !important;
    -ms-flex-direction: row;
    display: flex !important;
    flex-direction: row;
  }
  
  .module_17392866807073-vertical-alignment {
    display: -ms-flexbox !important;
    -ms-flex-direction: column !important;
    -ms-flex-pack: center !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
  }
  
  .module_17392866807073-vertical-alignment>div {
    flex-shrink: 0 !important;
  }
  
  .cell_1739286676881-row-0-vertical-alignment>.row-fluid {
    display: -ms-flexbox !important;
    -ms-flex-direction: row;
    display: flex !important;
    flex-direction: row;
  }
  
  .module_17392866768822-vertical-alignment {
    display: -ms-flexbox !important;
    -ms-flex-direction: column !important;
    -ms-flex-pack: center !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
  }
  
  .module_17392866768822-vertical-alignment>div {
    flex-shrink: 0 !important;
  }
  
  .cell_17152668791253-row-0-vertical-alignment>.row-fluid {
    display: -ms-flexbox !important;
    -ms-flex-direction: row;
    display: flex !important;
    flex-direction: row;
  }
  
  .module_17152668791256-vertical-alignment {
    display: -ms-flexbox !important;
    -ms-flex-direction: column !important;
    -ms-flex-pack: center !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
  }
  
  .module_17152668791256-vertical-alignment>div {
    flex-shrink: 0 !important;
  }
}

/* HubSpot Styles (default) */
.dnd_area-row-0-padding {
  padding-top: 50px !important;
  padding-bottom: 50px !important;
}

.dnd_area-row-0-background-layers {
  background-image: url('https://www.gnet.it/hubfs/Marketing%20Division%20%2814%29.png') !important;
  background-position: center center !important;
  background-size: cover !important;
  background-repeat: no-repeat !important;
}

.dnd_area-row-1-padding {
  padding-bottom: 0px !important;
}

.dnd_area-row-1-background-layers {
  background-image: linear-gradient(rgba(255, 255, 255, 1), rgba(255, 255, 255, 1)) !important;
  background-position: left top !important;
  background-size: auto !important;
  background-repeat: no-repeat !important;
}

.dnd_area-row-2-padding {
  padding-top: 20px !important;
  padding-bottom: 20px !important;
}

.dnd_area-row-3-padding {
  padding-top: 60px !important;
  padding-bottom: 60px !important;
}

.dnd_area-row-3-background-layers {
  background-image: linear-gradient(rgba(255, 255, 255, 1), rgba(255, 255, 255, 1)) !important;
  background-position: left top !important;
  background-size: auto !important;
  background-repeat: no-repeat !important;
}

.dnd_area-row-4-padding {
  padding-top: 30px !important;
  padding-bottom: 0px !important;
}

.dnd_area-row-4-background-layers {
  background-image: linear-gradient(rgba(207, 226, 243, 0.4), rgba(207, 226, 243, 0.4)) !important;
  background-position: left top !important;
  background-size: auto !important;
  background-repeat: no-repeat !important;
}

.dnd_area-row-5-padding {
  padding-top: 40px !important;
  padding-bottom: 0px !important;
}

.dnd_area-row-5-background-layers {
  background-image: linear-gradient(rgba(207, 226, 243, 0.3), rgba(207, 226, 243, 0.3)) !important;
  background-position: left top !important;
  background-size: auto !important;
  background-repeat: no-repeat !important;
}

.dnd_area-row-6-hidden {
  display: none !important;
}

.dnd_area-row-7-hidden {
  display: none !important;
}

.dnd_area-row-8-padding {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.dnd_area-row-8-hidden {
  display: none !important;
}

.dnd_area-row-9-hidden {
  display: none !important;
}

.cell_17159328100492-padding {
  padding-top: 80px !important;
  padding-bottom: 8px !important;
}

.dnd_area-dnd_partial-3-column-1-padding {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.dnd_area-dnd_partial-3-column-1-row-0-padding {
  padding-bottom: 20px !important;
}

.dnd_area-dnd_partial-3-column-1-row-1-padding {
  padding-bottom: 48px !important;
}

.dnd_area-dnd_partial-3-module-3-hidden {
  display: block !important;
}

.cell_17152579202105-padding {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.cell_17152579202105-row-0-padding {
  padding-top: 20px !important;
  padding-bottom: 20px !important;
}

.widget_1715850937749-hidden {
  display: none !important;
}

.module_1715850923799-hidden {
  display: none !important;
}

.dnd_area-dnd_partial-2-module-1-hidden {
  display: flex !important;
}

.cell_1739286680707-padding {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.cell_1739286680707-row-0-padding {
  padding-bottom: 80px !important;
}

.cell_1739286676881-padding {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.cell_1739286676881-row-0-padding {
  padding-bottom: 80px !important;
}

.cell_17152668791253-padding {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.cell_17152668791253-row-0-padding {
  padding-bottom: 80px !important;
}

.dnd_area-dnd_partial-9-column-1-padding {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.dnd_area-dnd_partial-9-column-1-row-0-padding {
  padding-bottom: 48px !important;
}

.dnd_area-dnd_partial-4-column-1-padding {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.dnd_area-dnd_partial-4-column-1-row-0-padding {
  padding-bottom: 48px !important;
}

.dnd_area_footer-row-0-padding {
  padding-top: 20px !important;
  padding-bottom: 20px !important;
}

.dnd_area_footer-row-0-background-layers {
  background-image: linear-gradient(rgba(66, 91, 118, 1), rgba(66, 91, 118, 1)) !important;
  background-position: left top !important;
  background-size: auto !important;
  background-repeat: no-repeat !important;
}

</style>
